import { formatLocal } from '../../shared/dates';

export const mapReportCellValue = (value, column, timeZone) => {
  if (column?.format === 'boolean') return value ? 'Yes' : 'No';
  if (column?.format === 'date' && value) return formatLocal(value, timeZone, 'yyyy-MM-dd HH:mm');
  if (value === null || value === undefined) return '';
  return String(value);
};

export const mapReportRowsForPdf = (rows, columns, timeZone) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  const safeColumns = Array.isArray(columns) ? columns : [];
  return safeRows.map((row) => safeColumns.map((column) => mapReportCellValue(row?.[column.field], column, timeZone)));
};
